import { getPublicRuntimeConfig } from "./runtime-config";
export const getUserAccounts = (idToken) => {
    const { DTN_PRODUCT_CODE } = getPublicRuntimeConfig();
    if (DTN_PRODUCT_CODE !== undefined) {
        const appInfoClaim = idToken["https://auth.dtn.com/appInfo"];
        const appInfo = appInfoClaim[DTN_PRODUCT_CODE];
        if (appInfo && "customers" in appInfo) {
            return appInfo.customers;
        }
    }
    return [];
};
